<template>
  <div class="home-container rounded-4 shadow-sm p-4 bg-white">
    <div class="welcome-card rounded-4 p-4 bg-primary text-white">
      <h1 class="display-5 fw-bold">
        <i class="fas fa-hand-wave me-2"></i> Bienvenue, <span v-if="this.$store.getters.membership.prenom">{{ this.$store.getters.membership.prenom }} </span>!
      </h1>
      <p class="lead">Nous sommes ravis de vous revoir dans votre espace freelance.</p>
      
      <div class="quick-stats mt-4">
        <div class="row g-3">
          <div class="col-md-4">
            <div class="stat-card p-3 rounded-3 bg-white text-dark shadow">
              <h5 class="fw-bold"><i class="fas fa-trophy text-primary me-2"></i> Réalisations</h5>
              <p class="mb-0">{{ achievementsCount }} projets realisés</p>
            </div>
          </div>
          <!-- <div class="col-md-4">
            <div class="stat-card p-3 rounded-3 bg-white text-dark shadow">
              <h5 class="fw-bold"><i class="fas fa-file-invoice text-primary me-2"></i> Factures</h5>
              <p class="mb-0">{{ pendingInvoices }} en attente</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="stat-card p-3 rounded-3 bg-white text-dark shadow">
              <h5 class="fw-bold"><i class="fas fa-calendar-check text-primary me-2"></i> Prochains RDV</h5>
              <p class="mb-0">{{ nextAppointment || 'Aucun RDV prévu' }}</p>
            </div>
          </div> -->
        </div>
      </div>
    </div>
    
    <!-- <div class="recent-activity mt-4 p-4 rounded-4 bg-light">
      <h3 class="mb-4"><i class="fas fa-bell me-2"></i>Dernières activités</h3>
      <ul class="list-group">
        <li v-for="(activity, index) in recentActivities" :key="index" 
            class="list-group-item rounded-3 mb-2 d-flex justify-content-between align-items-center">
          <span><i :class="activity.icon" class="me-2"></i> {{ activity.text }}</span>
          <small class="text-muted">{{ activity.date }}</small>
        </li>
      </ul>
    </div> -->
  </div>

</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      loading: false,
      achievementsCount: this.$store.getters.membership.realisations ? this.$store.getters.membership.realisations.length : 0,
      pendingInvoices: 2,
      nextAppointment: '15/06/2023 - 14h30',
      recentActivities: [
        { icon: 'fas fa-file-invoice', text: 'Facture #1234 envoyée', date: '10/06/2023' },
        { icon: 'fas fa-check-circle', text: 'Projet "Site Web" terminé', date: '05/06/2023' },
        { icon: 'fas fa-comment', text: 'Nouveau message reçu', date: '02/06/2023' }
      ]
    }
  },
  mounted() {
    // this.getFreelanceHistory()
  },
  methods: {
    async getFreelanceHistory() {
        this.loading = true
        try {
          const response = await this.axios.get('/api/membership/history', {
            username: this.$store.getters.user.name
          })
          this.recentActivities = response.data;
        } catch (error) {
            this.$toast.add({
              severity: 'error',
              summary: 'Probleme de connexion',
              detail: error.response.data.message,
              life: 5000
            });
        } finally {
          this.loading = false
        }
      },
  }
}
</script>

<style scoped>
.home-container {
  max-width: 1200px;
  margin: 0 auto;
}

.welcome-card {
  background: linear-gradient(135deg, #0d6efd 0%, #084298 100%);
}

.stat-card {
  transition: transform 0.3s;
}

.stat-card:hover {
  transform: translateY(-5px);
}

.list-group-item {
  transition: all 0.3s;
}

.list-group-item:hover {
  background-color: #f8f9fa;
  transform: translateX(5px);
}
</style>